import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsSalesByEmailCampaignQuery } from "../graphql/queries";
import type {
  AnalyticsSalesByEmailCampaignQueryType,
  AnalyticsSalesByEmailCampaignQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsSalesByEmailCampaignQuery = (
  options?: QueryHookOptions<
    AnalyticsSalesByEmailCampaignQueryType,
    AnalyticsSalesByEmailCampaignQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsSalesByEmailCampaignQueryType,
    AnalyticsSalesByEmailCampaignQueryVariablesType
  >(AnalyticsSalesByEmailCampaignQuery, options);
};
